<template>
    <div v-if="isVisible">
        <div class="col-lg-12 sk-mb-30">
            <div>
                <PuSkeleton class="sk-h-350" />
            </div>
        </div>
        <div class="sk-mb-30 d-flex px-4">
            <div class="col-lg-3 mb-5 d-flex p-3"> <!-- Added p-3 for padding -->
                <PuSkeleton class="sk-h-40 sk-w-20" />
            </div>
            <div class="col-lg-6 mb-5 p-3"> <!-- Added p-3 for padding -->
                <!-- Center content (if any) -->
            </div>
            <div class="col-lg-3 mb-5 d-flex p-3"> <!-- Added p-3 for padding -->
                <PuSkeleton class="sk-h-40 sk-w-20" />
            </div>
        </div>
    </div>
</template>

  
  <script>
  import Skeleton from "vue-loading-skeleton";
  
  export default {
    name: "CustomSkeleton",
    components: {
      Skeleton
    },
    props: {
      isVisible: {
        type: Boolean,
        default: true
      }
    }
  };
  </script>
  
  <style>
  /*css for skeleton*/
  .pu-skeleton {
    line-height: unset !important;
  }
  .sk-mb-30 {
    margin-bottom: 30px;
  }
  .sk-h-40 {
    height: 40px;
  }
  .sk-h-50 {
    height: 50px;
  }
  .sk-h-100 {
    height: 100px;
  }
  .sk-h-350 {
    height: 350px;
  }
  .sk-w-20 {
    width: 10px;
}

  .sk-w-200 {
    width: 200px;
  }
  .sk-mb-80 {
    margin-bottom: 80px;
  }
  
  </style>
  



// WEBPACK FOOTER //
// src/components/AthenaQuestionSkeleton.vue